import Nullstack from 'nullstack';
export default function IconBrandOkRu({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-ok-ru",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "9",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M20 12c0 8 0 8 -8 8s-8 0 -8 -8s0 -8 8 -8s8 0 8 8z"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 13c1.333 .667 3.667 .667 5 0"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 17l2.5 -3l2.5 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 13.5v.5"
  }), " ");
}